import { Fragment, useEffect, useState, useRef } from 'react';
import { Col, Card, CardHeader, Table, Form, FormGroup, Label, Input, ModalFooter, Row } from 'reactstrap';
import { Btn } from '../../AbstractElements';
import { useDispatch, useSelector } from 'react-redux';
import CommonModal from '../../Components/Modals/modal';
import Pagination from '../../Components/Pagination/Pagination';
import Empty from '../../Components/Empty/Index';
import SweetAlert from 'sweetalert2';
import { getCoupons, ModalToggle, isOpenModal, addCoupons, updateCoupons, deleteCoupons } from '../../store/couponSlice';
import Multiselect from 'multiselect-react-dropdown';
import { getUserList } from '../../store/userSlice';


const CouponsTable = () => {
  const storeVar = useSelector(state => state.coupons);
  const userVar = useSelector(state => state.user)
  const dispatch = useDispatch();
  const toggle = () => dispatch(ModalToggle());
  const [submit, setSubmit] = useState(false);
  const searchTimeoutRef = useRef(null);

  const handleSearch = (value) => {
    if (searchTimeoutRef.current) {
      clearTimeout(searchTimeoutRef.current);
    }
    searchTimeoutRef.current = setTimeout(() => {
      dispatch(getUserList(100, 0, value, '', '', false));
    }, 500);
  };

  const [formVar, setFormVar] = useState({
    keyword: '',
    limit: 10,
    offset: 0,
    currentPage: 1,
    status: 'active',
    modalTitle: '',
    editState: false,
    couponId: '',
    code: '',
    title: '',
    discountType: 'percentage',
    discountValue: '',
    maxDiscount: '',
    minAmount: '',
    appliesTo: 'all',
    eligibleCustomers: [],
    expiryDate: '',
  });

  useEffect(() => {
    dispatch(getCoupons());
    dispatch(getUserList(100, 0, ''))
  }, []);


  const EditToggleModal = (data) => {
    dispatch(isOpenModal(true));
    setFormVar(prev => ({
      ...prev,
      editState: true,
      couponId: data._id,
      modalTitle: 'Edit Coupon',
      code: data.code,
      title: data.title,
      discountType: data.discountType,
      discountValue: data.discountValue,
      maxDiscount: data.maxDiscount || '',
      minAmount: data.minAmount || '',
      appliesTo: data.appliesTo || 'all',
      eligibleCustomers: data.eligibleCustomers?.map((u) => {
        if (typeof u === 'object' && u !== null) {
          return {
            id: u._id,
            name: `${u.name || "Unknown"} (${u.phoneNumber || "N/A"})`
          };
        }
        return { id: u, name: u };
      }) || [],
      expiryDate: formatDateForInput(data.expiryDate) || '',
    }));
  };
  const formatDateForInput = (dateString) => {
    if (!dateString) return '';
    return new Date(dateString).toISOString().split('T')[0];
  };

  const AddToggleModal = () => {
    dispatch(isOpenModal(true));
    setFormVar(prev => ({
      ...prev,
      editState: false,
      modalTitle: 'Add Coupon',
      code: '',
      title: '',
      discountType: 'percentage',
      discountValue: '',
      maxDiscount: '',
      minAmount: '',
      appliesTo: 'all',
      eligibleCustomers: [],
      expiryDate: '',
    }));
  };

  const submitMenu = () => {
    if (couponValidation()) {
      setSubmit(true);
      return null;
    }
    setSubmit(false);

    const payload = {
      code: formVar.code,
      title: formVar.title,
      discountType: formVar.discountType,
      discountValue: parseFloat(formVar.discountValue),
      maxDiscount: formVar.maxDiscount ? parseFloat(formVar.maxDiscount) : undefined,
      minAmount: formVar.minAmount ? parseFloat(formVar.minAmount) : undefined,
      appliesTo: formVar.appliesTo,
      eligibleCustomers: formVar.eligibleCustomers?.map((u) => u.id) || [],
      expiryDate: formVar.expiryDate ? new Date(formVar.expiryDate) : undefined,
    };

    if (formVar.editState) {
      dispatch(updateCoupons(formVar.couponId, payload));
    } else {
      dispatch(addCoupons(payload));
    }
  };

  const couponValidation = () => {
    if (!formVar.code) return "Code is required";
    if (!formVar.title) return "Title is required";
    if (!formVar.discountValue) return "Discount Value is required";
    if (formVar.discountType === 'percentage' && (!formVar.maxDiscount || parseFloat(formVar.maxDiscount) <= 0)) return "Max discount required for percentage type";
  };

  const DeleteModel = (data) => {
    SweetAlert.fire({
      title: 'Are you sure?',
      text: 'Once deleted, you cannot recover this coupon!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Ok',
      cancelButtonText: 'Cancel',
      reverseButtons: true,
    }).then((result) => {
      if (result.value) {
        dispatch(deleteCoupons(data._id));
      }
    });
  };


  return (
    <Fragment>
      <Col sm="12">
        <Card>
          <CardHeader>
            <Row>
              <Col md="10"></Col>
              <Col md="2" className="d-flex justify-content-end align-items-center">
                <Btn
                  attrBtn={{ color: 'info-gradien', className: 'w-100', size: 'sm', onClick: AddToggleModal }}
                >
                  Add Coupon
                </Btn>
              </Col>
            </Row>
          </CardHeader>
          <div className="table-responsive">
            <Table hover className="table-border-horizontal table-light">
              <thead>
                <tr>
                  <th>Sl.No</th>
                  <th>Code</th>
                  <th>Title</th>
                  <th>Discount</th>
                  <th>Applies To</th>
                  <th>Status</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {storeVar.couponsData?.map((item, index) => (
                  <tr key={index}>
                    <th>{index + 1}</th>
                    <td>{item.code}</td>
                    <td>{item.title}</td>
                    <td>
                      {item.discountType === 'percentage' ? `${item.discountValue}%` : `${item.discountValue}`}
                    </td>
                    <td>{item.appliesTo}</td>
                    <td>
                      {
                        item.status === 'active' && <>
                          <span className={`font-success rounded-1 p-1 me-2 d-flex align-items-center`}>
                            <i className="fa fa-check-circle-o fa-lg" aria-hidden="true"></i>
                            &nbsp; <span>Active</span>
                          </span>
                        </>
                      }
                      {
                        item.status === 'pending' && <>
                          <span className={`font-warning rounded-1 p-1 me-2 d-flex align-items-center`}>
                            <i className="fa fa-clock-o fa-lg" aria-hidden="true"></i>
                            &nbsp; <span>Pending</span>
                          </span>
                        </>
                      }
                      {
                        item.status === 'DEACTIVE' && <>
                          <span className={`font-danger w-50 rounded-1 p-1 me-2 d-flex align-items-center`}>
                            {item.status === 'DEACTIVE' && (
                              <i className="fa fa-times-circle-o fa-lg" aria-hidden="true"></i>
                            )}
                            &nbsp; <span>{item.status}</span>
                          </span>
                        </>
                      }
                    </td>
                    <td>
                      <div className="d-flex gap-2 align-items-center">
                        <div className='cursor-pointer bg-light-primary font-primary action-icon'>
                          <i className="fa fa-edit fa-lg cursor-pointer" onClick={() => EditToggleModal(item)}></i>
                        </div>
                        <div className='cursor-pointer bg-light-info font-danger action-icon'>
                          <i className="fa fa-trash fa-lg cursor-pointer" onClick={() => DeleteModel(item)}></i>
                        </div>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
          {storeVar.totalCoupons <= 0 && <Empty />}
        </Card>
      </Col>

      <CommonModal isOpen={storeVar.isOpenModal} title={formVar.modalTitle} toggler={toggle}>
        <Form>
          <FormGroup>
            <Label>Code</Label>
            <Input
              type="text"
              placeholder="Enter coupon code"
              value={formVar.code}
              onChange={(e) => setFormVar(prev => ({ ...prev, code: e.target.value }))}
            />
          </FormGroup>

          <FormGroup>
            <Label>Title</Label>
            <Input
              type="text"
              placeholder="Enter coupon title"
              value={formVar.title}
              onChange={(e) => setFormVar(prev => ({ ...prev, title: e.target.value }))}
            />
          </FormGroup>

          <FormGroup>
            <Label>Discount Type</Label>
            <Input
              type="select"
              value={formVar.discountType}
              onChange={(e) => setFormVar(prev => ({ ...prev, discountType: e.target.value }))}
            >
              <option value="percentage">Percentage</option>
              <option value="flat">Flat</option>
            </Input>
          </FormGroup>

          <FormGroup>
            <Label>Discount Value</Label>
            <Input
              type="number"
              placeholder="Enter discount value"
              value={formVar.discountValue}
              onChange={(e) => setFormVar(prev => ({ ...prev, discountValue: e.target.value }))}
            />
          </FormGroup>

          {formVar.discountType === 'percentage' && (
            <FormGroup>
              <Label>Max Discount</Label>
              <Input
                type="number"
                placeholder="Enter max discount"
                value={formVar.maxDiscount}
                onChange={(e) => setFormVar(prev => ({ ...prev, maxDiscount: e.target.value }))}
              />
            </FormGroup>
          )}

          <FormGroup>
            <Label>Min Amount</Label>
            <Input
              type="number"
              placeholder="Enter minimum cart amount"
              value={formVar.minAmount}
              onChange={(e) => setFormVar(prev => ({ ...prev, minAmount: e.target.value }))}
            />
          </FormGroup>

          <FormGroup>
            <Label>Applies To</Label>
            <Input
              type="select"
              value={formVar.appliesTo}
              onChange={(e) => setFormVar(prev => ({ ...prev, appliesTo: e.target.value }))}
            >
              <option value="all">All Customers</option>
              <option value="new">New Customers</option>
              <option value="specific">Specific Customers</option>
            </Input>
          </FormGroup>

          {formVar.appliesTo === 'specific' && (
            <FormGroup>
              <Label>Eligible Customers (comma-separated IDs)</Label>
              {/* <Input
                type="text"
                placeholder="Enter eligible customer IDs"
                value={formVar.eligibleCustomers}
                onChange={(e) => setFormVar(prev => ({ ...prev, eligibleCustomers: e.target.value }))}
              /> */}
              <Multiselect
                options={userVar.examUserList?.map((user) => ({
                  id: user._id,
                  name: `${user.name || "Unknown"} (${user.phoneNumber || "N/A"})`,
                })) || []}
                selectedValues={formVar.eligibleCustomers}
                onSelect={(selectedList) =>
                  setFormVar((prev) => ({
                    ...prev,
                    eligibleCustomers: selectedList,
                  }))
                }
                onRemove={(selectedList) =>
                  setFormVar((prev) => ({
                    ...prev,
                    eligibleCustomers: selectedList,
                  }))
                }
                onSearch={handleSearch}
                displayValue="name"
              />

            </FormGroup>
          )}

          <FormGroup>
            <Label>Expiry Date</Label>
            <Input
              type="date"
              value={formVar.expiryDate}
              onChange={(e) => setFormVar(prev => ({ ...prev, expiryDate: e.target.value }))}
            />
          </FormGroup>

        </Form>
        <ModalFooter>
          <Btn attrBtn={{ color: 'secondary', onClick: toggle }}>Close</Btn>
          <Btn attrBtn={{ color: 'primary', onClick: submitMenu }}>Save Changes</Btn>
        </ModalFooter>
      </CommonModal>
    </Fragment>
  );
};

export default CouponsTable;
